import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  ${({ theme, $breakpoint }) => {
    return css`
      gap: ${theme.spacing[$breakpoint === 'mobile' ? 4 : 6]}px;
    `;
  }}
`;

export const Indice = styled.div<{ $indiceAtual: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ theme }) => {
    return css`
      gap: ${theme.spacing[1]}px;
    `;
  }}

  ${({ $indiceAtual }) => {
    if (!$indiceAtual)
      return css`
        opacity: 0.25;
      `;
    return '';
  }}
`;

export const BolinhaIndice = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  ${({ theme }) => {
    return css`
      background-color: ${theme.colors.default.white};
    `;
  }}
`;
